module.exports = __webpack_public_path__ + "static/media/AO.eb63be02.svg";